"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProdNetworkQualitySDK = void 0;
const rxjs_1 = require("rxjs");
const RxOp = __importStar(require("rxjs/operators"));
const networkQuality_1 = require("./networkQuality");
const DownloadController_1 = require("./controllers/DownloadController");
const Upload_1 = require("./controllers/Upload");
const PingController_1 = require("./controllers/PingController");
const ModemController_1 = require("./controllers/ModemController");
const prepare_1 = require("./controllers/prepare");
const NQError_1 = require("./NQError");
const convertToNQError_1 = require("./util/convertToNQError");
const BenchmarkController_1 = require("./controllers/BenchmarkController");
const observable_1 = require("./util/observable");
const R = __importStar(require("ramda"));
const NQValue_1 = require("./NQValue");
const utils_1 = require("./util/utils");
const api_1 = require("../api");
class ProdNetworkQualitySDK extends networkQuality_1.NetworkQualitySDK {
    constructor(baseUrl, apiKey, options) {
        var _a, _b;
        super();
        this.options = options;
        this.downloadController = null;
        this.pingController = null;
        this.speedtest = () => {
            const self = this;
            return this.prepare().pipe(RxOp.mergeMap(prepareResult => (0, rxjs_1.concat)((0, rxjs_1.of)(prepareResult), self.benchmark(prepareResult), self.download(prepareResult), self.upload(prepareResult), self.ping(prepareResult), self.complete(prepareResult), self.modem(prepareResult), self.hintsForResult(prepareResult))), RxOp.catchError(err => {
                self.logger.error('Handling error locally and rethrowing it...', err);
                return (0, rxjs_1.throwError)(() => (0, convertToNQError_1.convertToNQError)(err));
            }));
        };
        this.prepare = (options) => {
            return (0, prepare_1.processPrepare)(this.speedtestApi, this.options, options);
        };
        this.benchmark = (prepareResult) => {
            if (!R.isNil(prepareResult.config.cpuBenchmark) && prepareResult.config.cpuBenchmark === false) {
                return (0, rxjs_1.of)((0, NQValue_1.createBenchmarkFinalDidNotRun)());
            }
            const reportResultsToServer = (results) => {
                const [r1, r2] = results;
                if (r1 === undefined ||
                    r2 === undefined ||
                    r1.value.kind !== NQValue_1.NQValueKind.BenchmarkIntermediate ||
                    r2.value.kind !== NQValue_1.NQValueKind.BenchmarkFinalAvailable) {
                    return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Bm-1", `got: ${(0, utils_1.safeStringify)(results)}`));
                }
                ;
                const items = [{
                        value: Math.round(r1.value.result1),
                        duration: r1.interval * 1e-3
                    }].concat(r2.value.result2 !== null ? [{
                        value: Math.round(r2.value.result2),
                        duration: r2.interval * 1e-3
                    }] : []);
                const requestData = {
                    speedtestId: prepareResult.init.speedtest.id,
                    iterations: items
                };
                return this.speedtestApi.calcBenchmark(requestData).pipe(RxOp.ignoreElements());
            };
            return (0, BenchmarkController_1.getBenchmarkObservable)(this.logger).pipe((0, observable_1.summarizeThrough)(reportResultsToServer), RxOp.catchError(err => {
                return (0, rxjs_1.throwError)(() => {
                    if ((0, NQError_1.isNqError)(err)) {
                        return err;
                    }
                    else if (err instanceof rxjs_1.TimeoutError) {
                        return (0, NQError_1.createNqError)("Bm-3", "Benchmark Timeout Error", err);
                    }
                    else {
                        return (0, NQError_1.createNqError)("Cl-19", "Benchmark Observable Error", err);
                    }
                });
            }), RxOp.map(v => v.value), RxOp.map(v => {
                switch (v.kind) {
                    case NQValue_1.NQValueKind.BenchmarkIntermediate:
                        return (0, NQValue_1.createBenchmarkIntermediate)(v.result1);
                    case NQValue_1.NQValueKind.BenchmarkFinalAvailable:
                        return (0, NQValue_1.createBenchmarkFinalAvailable)(v.result1, v.result2);
                }
            }), RxOp.map(v => v));
        };
        this.calcDownload = (data) => {
            return this.speedtestApi.calcDownload(data).pipe(RxOp.map(result => (0, NQValue_1.createDownloadFinal)(result.data.value, result.data.jitter)));
        };
        this.upload = (prepareResult) => {
            const uploadPublisher = this.getUploadPublisher();
            const source = uploadPublisher(prepareResult.config.upload.maxBytes, getUploadServer(prepareResult), this.logger).pipe(RxOp.repeat(), RxOp.timeInterval(), RxOp.map(v => v.value));
            const self = this;
            return (0, observable_1.collectIntermediates)(prepareResult.config.upload.duration, prepareResult.config.upload.interval, [source]).pipe(
            /*
              Ignoring the first intermediate result whose value is larger than 60 Mbps.
              This is to avoid show unrealistically high speeds on situations where XMLHttpRequest
              onprogress event reports unrealistically fast progress.
              See ticket: https://gitlab.com/anw.net/vodafone/html-speedtest/-/issues/272
            */
            RxOp.filter((loadChunk, index) => (0, utils_1.speedOfLoadChunk)(loadChunk) < 60e6 || index >= 1), (0, observable_1.smoothing)(), RxOp.map(v => ({
                nqValue: (0, NQValue_1.createUploadIntermediate)((0, utils_1.speedOfLoadChunk)(v.smoothed)),
                attachment: v
            })), (0, observable_1.summarizeThrough)((intermediate => {
                if (intermediate.length === 0) {
                    throw (0, NQError_1.createNqError)("Up-Cn-3", "No intermediate results.");
                }
                const total = (0, utils_1.sumLoadChunks)(intermediate.map(v => v.attachment.original));
                const data = {
                    speedtestId: prepareResult.init.speedtest.id,
                    transferDuration: total.duration,
                    transferredBytes: total.byteCount,
                    intermediateValues: intermediate.map(v => (0, utils_1.speedOfLoadChunk)(v.attachment.original))
                };
                return self.calcUpload(data).pipe(RxOp.map(result => ({
                    nqValue: result,
                    attachment: { original: total, smoothed: total }
                })));
            })), RxOp.map(v => v.nqValue) // Drop the attachment
            );
        };
        this.calcUpload = (data) => {
            return this.speedtestApi.calcUpload(data).pipe(RxOp.map(result => (0, NQValue_1.createUploadFinal)(result.data.value, result.data.jitter)));
        };
        this.ping = (prepareResult) => {
            const self = this;
            const result = new rxjs_1.Observable((observer) => {
                self.pingController = new PingController_1.PingController(this.logger);
                const c = prepareResult.config.ping;
                self.pingController.pingMaxNum = Math.ceil(c.duration / c.interval);
                self.pingController.pingMaxTime = c.duration;
                self.pingController.pingDelay = c.interval;
                self.pingController.url = getPingServer(prepareResult);
                self.pingController.onPingIntermediate = (pingTime) => {
                    observer.next((0, NQValue_1.createPingIntermediate)(pingTime));
                };
                self.pingController.onPingComplete = (data) => {
                    if (data.intermediateValues.length === 0) {
                        observer.error((0, NQError_1.createNqError)("Pn-Cn-2", "Ping intermediate value list is empty"));
                        return;
                    }
                    const pingRequestModel = Object.assign(Object.assign({}, data), { speedtestId: prepareResult.init.speedtest.id });
                    self.speedtestApi.calcPing(pingRequestModel).subscribe({
                        next: result => observer.next((0, NQValue_1.createPingFinal)(result.data.value, result.data.jitter)),
                        complete: () => observer.complete(),
                        error: err => observer.error(err)
                    });
                };
                self.pingController.onPingError = (e) => {
                    observer.error((0, NQError_1.createNqError)("Pn-Cn-1", `Ping Error: ${e}`));
                    observer.error(e);
                };
                self.pingController.start();
                const tearDown = () => {
                    var _a;
                    (_a = self.pingController) === null || _a === void 0 ? void 0 : _a.stop();
                };
                return tearDown;
            });
            return result;
        };
        this.complete = (prepareResult) => {
            const speedtestId = prepareResult.init.speedtest.id;
            return this.speedtestApi.complete({ speedtestId }).pipe(RxOp.map(_ => ({ kind: NQValue_1.NQValueKind.Complete })));
        };
        this.abort = (prepareResult) => {
            const speedtestId = prepareResult.init.speedtest.id;
            this.logger.info(`Request /abort. SpeedtestID = ${speedtestId}`);
            return this.speedtestApi.abort({ speedtestId }).pipe(RxOp.ignoreElements());
        };
        this.abortScheme = (abortSchemeRequestModel) => {
            return this.speedtestApi.abortScheme(abortSchemeRequestModel).pipe(RxOp.ignoreElements());
        };
        this.modem = (prepareResult) => {
            return (0, ModemController_1.modemMeasurement)(prepareResult, this.speedtestApi);
        };
        this.print = (printRequestModel) => {
            return this.speedtestApi.print(printRequestModel);
        };
        this.updateValue = (key, command) => {
            return this.speedtestApi.updateValue({ key, command }).pipe(RxOp.map((response) => {
                return response.data;
            }));
        };
        this.speedtestApi = (0, api_1.createSpeedtestApi)(baseUrl, apiKey, options.logger, (_a = options.defaultTimeout) !== null && _a !== void 0 ? _a : null, (_b = options.useRequestId) !== null && _b !== void 0 ? _b : false, options.logRetry);
        this.logger = options.logger;
    }
    download(prepareResult) {
        const self = this;
        const result = new rxjs_1.Observable((observer) => {
            self.downloadController = new DownloadController_1.DownloadController(this.logger);
            self.downloadController.config.server.testServers = getDownloadServers(prepareResult);
            self.downloadController.num_download_streams = prepareResult.config.download.numStreams;
            self.downloadController.download_time = prepareResult.config.download.duration;
            self.downloadController.download_interval_time = prepareResult.config.download.interval * 1000;
            self.downloadController.onDownloadIntermediate = (speed_bps) => {
                observer.next((0, NQValue_1.createDownloadIntermediate)(speed_bps));
            };
            self.downloadController.onError = (err) => {
                this.logger.debug("DOWNLOAD ERROR");
                observer.error((0, NQError_1.createNqError)("Dn-Cn-1", "Download Error", err));
            };
            self.downloadController.onTimeout = (err) => {
                this.logger.debug("DOWNLOAD TIMEOUT");
                observer.error((0, NQError_1.createNqError)("Dn-Cn-2", "Download Timeout", err));
            };
            self.downloadController.onDownloadComplete = () => {
                var _a, _b, _c, _d;
                const speed_kbps = self.downloadController.result.download_raw;
                const speed_bps = speed_kbps.map(v => v * 1e3);
                const data = {
                    speedtestId: prepareResult.init.speedtest.id,
                    intermediateValues: speed_bps,
                    transferDuration: ((_b = (_a = self.downloadController) === null || _a === void 0 ? void 0 : _a.result.overall_time.download) !== null && _b !== void 0 ? _b : 0) / 1e3,
                    transferredBytes: (_d = (_c = self.downloadController) === null || _c === void 0 ? void 0 : _c.result.overall_bytes.download) !== null && _d !== void 0 ? _d : 0
                };
                self.calcDownload(data).subscribe({
                    next: result => observer.next(result),
                    complete: () => observer.complete(),
                    error: err => observer.error(err)
                });
            };
            self.downloadController.startDownload();
            const tearDown = () => {
                var _a;
                (_a = self.downloadController) === null || _a === void 0 ? void 0 : _a.stop();
            };
            return tearDown;
        });
        return result;
    }
    getUploadPublisher() {
        return Upload_1.xhrUploadPublisher;
    }
    hintsForResult(prepareResult) {
        return this.hints(prepareResult.init.speedtest.id).pipe(RxOp.map(res => (0, NQValue_1.createHints)(res)));
    }
    hints(speedtestId) {
        return this.speedtestApi.tipsKeys(speedtestId !== null && speedtestId !== void 0 ? speedtestId : "")
            .pipe(RxOp.map(res => res.data.map(d => ({ id: d }))), RxOp.catchError(err => {
            return (0, rxjs_1.throwError)(() => (0, convertToNQError_1.convertToNQError)(err));
        }));
    }
}
exports.ProdNetworkQualitySDK = ProdNetworkQualitySDK;
const getDownloadServers = (prepareResult) => {
    if (prepareResult.isIPv6) {
        return prepareResult.init.speedtest.servers.downloadServers.ipv6;
    }
    else {
        return prepareResult.init.speedtest.servers.downloadServers.dualstack;
    }
};
const getUploadServer = (prepareResult) => {
    if (prepareResult.isIPv6) {
        return prepareResult.init.speedtest.servers.uploadServer.ipv6;
    }
    else {
        return prepareResult.init.speedtest.servers.uploadServer.dualstack;
    }
};
const getPingServer = (prepareResult) => {
    if (prepareResult.isIPv6) {
        return prepareResult.init.speedtest.servers.wsPingServer.ipv6;
    }
    else {
        return prepareResult.init.speedtest.servers.wsPingServer.dualstack;
    }
};
//# sourceMappingURL=prodNetworkQualitySDK.js.map